import {MarkdownEditor} from '@github-ui/markdown-editor'

export const CommentBoxButton = MarkdownEditor.ActionButton
